<template>
  <div>
    <div class="my-4 py-1">
      <div class="d-flex align-items-center mb-2">
        <i class="fas fa-info-circle mr-2 text-orange"></i>
        <div class="color-gray-7 font-16 font-weight-bold">
          Descripción del Material/Equipo
        </div>
      </div>
      <div>
        <span class="data-title">Descripción:</span>
        <p>{{ item.description | empty }}</p>
      </div>
    </div>
    <div>
      <div class="d-flex align-items-center mb-2">
        <i class="fas fa-map-marker-alt mr-2 text-orange"></i>
        <div class="color-gray-7 font-16 font-weight-bold">
          Información de Locación
        </div>
      </div>
      <div>
        <span class="data-title">Datos de Ubicación / Dirección:</span>
        <p>{{ item.address | empty }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AdditionalInfo',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style lang="scss"></style>
